export const MAX_STEP_RESPONSIBLES = 10
